import {
  FORM_TYPES,
  newDataIsNotSavedText,
} from "@feniks-pwa/web-app/web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/constants";
import { useFormikContext } from "formik";
import _ from "lodash";
import { bool, func, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";

import ChangeDataFormWrapper from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/ChangeDataFormWrapper/changeDataFormWrapper";
import {
  getData,
  updateDataInDraft,
} from "web/Pages/Checkout/Subscription/BenefitSummary/BenefitForm/utils";

import __ from "web/Layout/Translations";

import useModalNotification from "web/hooks/useModalNotification";

import { setNotificationError } from "web/features/app/appSlice";

const CheckoutSubscriptionEditActiveBenefitSingleForm = ({
  handleCancelation,
  fieldsStructured,
  receiver,
  formId,
  benefitId,
  benefitUUID,
  formUUID,
  onSuccessChanged,
  isMyBenefitsView,
  allowChangingPersonalData,
}) => {
  const [, setModalLoaderNotification] = useModalNotification();
  const [isLoading, setIsLoading] = useState(false);
  const { values, validateForm } = useFormikContext();

  const dispatch = useDispatch();

  const formPath = `${benefitId}.forms.${formId}.fields`;
  const fieldValues = _.get(values, formPath);

  const sendData = () => {
    validateForm().then((errors) => {
      const fieldErrors = _.get(errors, formPath);
      if (isMyBenefitsView) setModalLoaderNotification();

      if (_.isEmpty(fieldErrors)) {
        if (!isMyBenefitsView) setIsLoading(true);
        updateDataInDraft(
          benefitUUID,
          {
            id: formUUID,
            receiver,
            fields: fieldValues,
          },
          FORM_TYPES.FORMS,
          () => onSuccessChanged(fieldValues),
          () => {
            dispatch(
              setNotificationError({ message: __(newDataIsNotSavedText) })
            );
            if (!isMyBenefitsView) setIsLoading(false);
          },
          isMyBenefitsView
        );
      }
    });
  };
  return (
    <ChangeDataFormWrapper
      onCancelClick={handleCancelation}
      onSendClick={sendData}
      areButtonsDisabled={isLoading}
    >
      {getData(
        fieldsStructured,
        receiver,
        formId,
        "forms",
        benefitId,
        true,
        allowChangingPersonalData
      )}
    </ChangeDataFormWrapper>
  );
};

CheckoutSubscriptionEditActiveBenefitSingleForm.propTypes = {
  handleCancelation: func.isRequired,
  receiver: string.isRequired,
  formId: string.isRequired,
  benefitId: string.isRequired,
  benefitUUID: string.isRequired,
  formUUID: string.isRequired,
  onSuccessChanged: func.isRequired,
  isMyBenefitsView: bool.isRequired,
  allowChangingPersonalData: bool.isRequired,
};

export default CheckoutSubscriptionEditActiveBenefitSingleForm;
